import { render, staticRenderFns } from "./AnnotationCreateModal.vue?vue&type=template&id=94905882&scoped=true&"
import script from "./AnnotationCreateModal.vue?vue&type=script&lang=js&"
export * from "./AnnotationCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationCreateModal.vue?vue&type=style&index=0&id=94905882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94905882",
  null
  
)

export default component.exports